import data from "../../.sourceflow/employer_pages.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const employer_page_helper = new CollectionHelper(data);
